import { API_URL, API_TOKEN } from "../api/apiConfig";

export const fetchMeetupspagecity = async () => {
  try {
    const response = await fetch(`${API_URL}/upcoming_meetupscity`, {
      headers: {
        Authorization: `Bearer ${API_TOKEN}`,
      },
    });

    return await response.json();
  } catch (error) {
    console.log("Meetupscity API Error:", error);
    return null;
  }
};
